import './bootstrap'
import '../css/app.css'

import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import * as Sentry from '@sentry/react'
import AuthenticatedLayout from '@/Layouts/AuthenticatedLayout'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { FlashProvider } from '@/Components/Feedback/FlashProvider'
import { createSentryOptions } from '@/Utils/createSentryOptions'

type InitialPageProps = {
    sentryRelease?: string | null
}

createInertiaApp({
    title: (title) => `${title} - monatsabschluss.at`,
    layout: () => AuthenticatedLayout,
    resolve: async (name) =>
        (await resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob(['./Pages/**/*.tsx', '!./Pages/**/*.test.tsx']))) as any,
    setup({ el, App, props }) {
        const pageProps = props.initialPage.props as InitialPageProps

        Sentry.init(createSentryOptions({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            release: pageProps.sentryRelease ?? undefined,
        }))

        const root = createRoot(el)

        root.render(
            <FlashProvider>
                <App {...props} />
            </FlashProvider>
        )
    },
    progress: {
        color: '#4B5563',
    },
})
